import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import { toggleBanner, requestReportStatus, requestReportStatusV2, downloadReport } from './actions';
import { status, type, showBanner, isIdle, isError, isDownloading, exportId, downloadId, downloadUrl } from './reducer';
import { enableModal } from '../components/modal/actions';

import { TranslatedCopy } from '../intl/TranslatedCopy';

import { H3, Icon, Button } from '../components';

import { STATUS, STATUS_NO_RESULTS } from './constants';

let TIMEOUT = null;

export class DownloadBanner extends Component {
  componentDidUpdate(prevProps) {
    const { status, downloadId, downloadUrl } = this.props;
    if (prevProps.status !== status) this.statusCheck();
    if (prevProps.downloadId !== downloadId || prevProps.downloadUrl !== downloadUrl) this.downloadCompletedReport();
  }

  timeoutCleanUp = () => {
    clearTimeout(TIMEOUT);
    TIMEOUT = null;
  };

  statusCheck = () => {
    this.timeoutCleanUp();

    const { isDownloading, requestReportStatus, requestReportStatusV2, type, exportId } = this.props;
    if (isDownloading) {
      if (exportId && exportId !== '') {
        if (type === 'downloads.type.report.rs') {
          requestReportStatusV2(exportId);
        } else {
          requestReportStatus(exportId);
          // For legacy Re-check status every 10 seconds while in download state
          TIMEOUT = setTimeout(this.statusCheck, 10000);
          return;
        }
      }

      // Re-check status every 1 second while in download state for new report
      TIMEOUT = setTimeout(this.statusCheck, 1000);
    }
  };

  downloadCompletedReport = () => {
    const { downloadReport, downloadId, downloadUrl, enableModal, type, intl } = this.props;
    const translatedTitle = type ? intl.formatMessage({ id: type }) : '';

    if (downloadUrl !== '') {
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      enableModal();
    } else if (downloadId !== '') {
      downloadReport(downloadId).then(response => {
        const { type, payload } = response;

        if (type && type.indexOf('SUCCESS') !== -1) {
          enableModal();

          payload.blob({ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }).then(blob => {
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const filename = `Gameday${translatedTitle.replace(/\s+/g, '')}.xlsx`;

            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('target', '_blank');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
        }
      });
    }
  };

  render() {
    const { status, type, showBanner, isIdle, isDownloading, isError, toggleBanner, intl } = this.props;

    // TODO: This needs REAL localization
    const translatedTitle = type ? intl.formatMessage({ id: type }) : '';
    const translatedStatus = STATUS[status] ? intl.formatMessage({ id: STATUS[status] }) : '';

    return showBanner && !isIdle ? (
      <div
        className={classnames(
          'downloadBanner',
          'p1-sm pl4-sm p3-md pl6-md u-full-width flex-container row space-between align-center'
        )}
      >
        <H3
          className={classnames(`downloadBanner__header${isDownloading ? '_loading' : ''}`, {
            'text-color-error': isError,
            'text-color-primary-light': !isError
          })}
        >
          {status === STATUS_NO_RESULTS ? (
            translatedStatus
          ) : (
            <div style={{ display: 'flex' }}>
              {translatedTitle}
              <div className='pr1-sm' />
              {translatedStatus}
            </div>
          )}
        </H3>
        <Button className='downloadBanner__dismiss flex-container row end align-center' onClick={toggleBanner}>
          <p className='body-4 mr1-sm text-color-primary-light'>
            <TranslatedCopy id='downloads.dismiss' />
          </p>
          <Icon name='filled-x' alt={intl.formatMessage({ id: 'downloads.dismiss' })} />
        </Button>
      </div>
    ) : null;
  }
}

DownloadBanner.propTypes = {
  status: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  showBanner: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  isIdle: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  exportId: PropTypes.string.isRequired,
  downloadId: PropTypes.string.isRequired,
  downloadUrl: PropTypes.string.isRequired,
  // --
  toggleBanner: PropTypes.func.isRequired,
  requestReportStatus: PropTypes.func.isRequired,
  requestReportStatusV2: PropTypes.func.isRequired,
  downloadReport: PropTypes.func.isRequired,
  enableModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  status: status(state),
  type: type(state),
  showBanner: showBanner(state),
  isIdle: isIdle(state),
  isError: isError(state),
  isDownloading: isDownloading(state),
  exportId: exportId(state),
  downloadId: downloadId(state),
  downloadUrl: downloadUrl(state)
});

const connector = connect(mapStateToProps, {
  toggleBanner,
  requestReportStatus,
  requestReportStatusV2,
  downloadReport,
  enableModal
});

export default injectIntl(connector(DownloadBanner));
